import React from 'react';
import { RefreshCw } from 'lucide-react';

interface ProjectSwitchingOverlayProps {
    switchingProject: boolean;
    darkMode: boolean;
    projects: Record<string, { shortName?: string; short_name?: string;[key: string]: any }>;
    currentProjectId: string | null;
}

const ProjectSwitchingOverlay: React.FC<ProjectSwitchingOverlayProps> = ({ switchingProject, darkMode, projects, currentProjectId }) => {
    if (!switchingProject) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className={`p-6 rounded-lg shadow-xl ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <RefreshCw className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
                <p className={`font-medium ${darkMode ? 'text-white' : 'text-gray-700'}`}>
                    Switching to {currentProjectId ? (projects[currentProjectId]?.shortName || projects[currentProjectId]?.short_name) : ''}...
                </p>
                <p className={`text-sm mt-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    Loading project data...
                </p>
            </div>
        </div>
    );
};

export default ProjectSwitchingOverlay;
